import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Signin from "./pages/Signin";
import ConfirmOutlet from "./pages/ConfirmOutlet";
import Register from "./pages/Register";
import ConfirmOTP from "./pages/ConfirmOTP";
import ConfirmVoucher from "./pages/ConfirmVoucher";
import Profile from "./pages/Profile";
// import Require from "./pages/Require";
import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import DetailNotifications from "./pages/DetailNotifications";
import ErrorBoundary from "./ErrorBoundary";
import Withdraw from "./pages/Withdraw";
import { handleOnError } from "./middleware/Error";
// import LuckyWheel from "./pages/LuckyWheel";

function App() {
  return (
    <ErrorBoundary errorHandler={handleOnError}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/confirm-voucher" element={<ConfirmVoucher />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/register" element={<Register />} />
          <Route path="/confirm-otp" element={<ConfirmOTP />} />
          <Route path="/confirm-outlet" element={<ConfirmOutlet />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/detail-notification"
            element={<DetailNotifications />}
          />
          <Route path="/withdraw" element={<Withdraw />} />
          {/* <Route path="/lucky-wheel-demo" element={<LuckyWheel />} /> */}
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
